import { Cover } from './Cover';

export { useCoverRenderer } from './hooks';

export default Cover;
